<template>
  <div
    class="bg-[#828282] rounded-md object-cover overflow-hidden"
    ref="loadImage"
    :class="str"
    :style="{ width: props.width + 'px', height: props.height + 'px' }"></div>
</template>

<script lang="ts" setup>
import { ref, onMounted, nextTick } from "vue";
import defaultImage from "@/assets/images/default_user_avatar.svg";

const loadImage = ref();
const str = ref<string | undefined>();

const props = defineProps({
  src: {
    type: String,
    default: defaultImage
  },
  width: {
    type: Number,
    default: 60
  },
  height: {
    type: Number,
    default: 60
  },
  default: {
    type: String,
    default: defaultImage
  }
});

const generateClass = () => {
  return "load-image" + Math.floor(Math.random() * 1000);
};

const initPage = () => {
  str.value = generateClass();

  nextTick(() => {
    if (loadImage.value) {
      const dom = document.querySelector("." + str.value);
      const image = new Image();
      image.src = props.src;
      image.style.width = "100%";
      image.style.height = "100%";
      image.onload = () => {
        dom?.appendChild(image);
      };
      image.onerror = () => {
        image.src = props.default;
        dom?.appendChild(image);
      };
    }
  });
};
onMounted(() => {
  initPage();
});
</script>
